export default __webpack_public_path__ + "ca2468f00f28b596c216da62f5a059ea.png";